function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { forwardRef, useRef, useState } from "react";
import { Transition as RTGTransition } from "react-transition-group";
import { useStyles } from "./Transition.style";
import useComposedRef from "../../hooks/useComposedRef";
import { resolveIds } from "../../utils/resolveIds";
var Transition = forwardRef(function(_param, ref) {
    var appear = _param.appear, children = _param.children, duration = _param.duration, _easing = _param.easing, easing = _easing === void 0 ? 'productive.easeInOut' : _easing, _enter = _param.enter, enter = _enter === void 0 ? true : _enter, _exit = _param.exit, exit = _exit === void 0 ? true : _exit, inProp = _param.in, onEnter = _param.onEnter, onEntered = _param.onEntered, onEntering = _param.onEntering, onExit = _param.onExit, onExited = _param.onExited, onExiting = _param.onExiting, testID = _param.testID, transitions = _param.transitions, rest = _objectWithoutProperties(_param, [
        "appear",
        "children",
        "duration",
        "easing",
        "enter",
        "exit",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "testID",
        "transitions"
    ]);
    var transitionRef = useRef(null);
    var combinedRef = useComposedRef(ref, transitionRef);
    var styles = useStyles({
        transitions: transitions,
        easing: easing,
        duration: duration,
        enter: enter,
        exit: exit
    });
    var _$ref1 = _slicedToArray(useState(function() {
        if (appear) {
            return inProp ? 'appear' : 'exited';
        }
        return inProp ? 'entered' : 'exited';
    }), 2), status = _$ref1[0], setStatus = _$ref1[1];
    var handleEnter = function(isAppearing) {
        setStatus(isAppearing ? 'appear' : 'enter');
        onEnter === null || onEnter === void 0 ? void 0 : onEnter(isAppearing);
    };
    var handleEntering = function(isAppearing) {
        var _$ref;
        transitionRef === null || transitionRef === void 0 ? void 0 : (_$ref = transitionRef.current) === null || _$ref === void 0 ? void 0 : _$ref.scrollTop;
        setStatus(isAppearing ? 'appearing' : 'entering');
        onEntering === null || onEntering === void 0 ? void 0 : onEntering(isAppearing);
    };
    var handleEntered = function(isAppearing) {
        setStatus(isAppearing ? 'appeared' : 'entered');
        onEntered === null || onEntered === void 0 ? void 0 : onEntered(isAppearing);
    };
    var handleExit = function() {
        setStatus('exit');
        onExit === null || onExit === void 0 ? void 0 : onExit();
    };
    var handleExiting = function() {
        setStatus('exiting');
        onExiting === null || onExiting === void 0 ? void 0 : onExiting();
    };
    var handleExited = function() {
        setStatus('exited');
        onExited === null || onExited === void 0 ? void 0 : onExited();
    };
    return _jsx(RTGTransition, _objectSpread({}, rest, {
        appear: appear,
        in: inProp,
        nodeRef: transitionRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        timeout: duration,
        children: typeof children === 'function' ? children({
            ref: combinedRef,
            styles: styles[status],
            testID: testID
        }) : _jsx("div", _objectSpread({
            ref: combinedRef,
            css: styles[status]
        }, resolveIds(undefined, testID), {
            children: children
        }))
    }));
});
export { Transition };
export default Transition;
